import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { observer, inject } from "mobx-react";

const en = require("../assets/img/header/EN.png");
const he = require("../assets/img/header/HE.png");

const Container = styled.div(({ ...props }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: props.lang === "en" ? "row" : "row-reverse",
  fontFamily: "NotoSansHebrew",
  fontSize: "14px",
  color: "#8C95A3",
  fontWeight: 500,
}));

const Image = styled.div(() => ({
  flexBasis: "40%",
}));

const Text = styled.div(() => ({
  marginLeft: "5px",
  marginBottom: "3px",
}));

const ChangeLanguage = ({ userStore }) => {
  const { t, i18n } = useTranslation("header");
  const [lang, setLang] = useState(window.localStorage.getItem("lang") || userStore.language);

  useEffect(() => {
    changeLanguageHandler(lang);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang]);

  const changeLanguageHandler = async (lang) => {
    if (lang !== userStore.language) {
      await i18n.changeLanguage(lang);
      await userStore.setLanguage(lang);
      window.localStorage.setItem("lang", lang);
      setLang(lang);
    }
  };

  const setImage = lang === "en" ? he : en;

  return (
    <Container lang={userStore.language}>
      <Image>
        <img
          src={setImage}
          style={{ display: lang === "en" ? "none" : "inline-block" }}
          alt="English"
          onClick={() => changeLanguageHandler("en")}
        />
        <img
          src={setImage}
          style={{
            display: lang === "he" ? "none" : "inline-block",
            verticalAlign: "text-top",
          }}
          alt="Hebrew"
          onClick={() => changeLanguageHandler("he")}
        />
      </Image>
      <Text>{t("language")}</Text>
    </Container>
  );
};
export default inject("userStore")(observer(ChangeLanguage));
